import styled from 'styled-components';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';
import { radius } from 'src/styles/Themes/Metrics';
import Palette from '@/styles/Themes/Palette';

export const Wrapper = styled.a`
    position: relative;
    display: flex;
    border-radius: ${radius.small};
    overflow: hidden;
    height: 100%;
    width: 100%;
    box-shadow: 0px 3.89px 23.3587px rgba(16, 31, 46, 0.53);
`;

export const Gradient = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 31.6%, rgba(0, 0, 0, 0.468) 73.45%);
`;

export const Image = styled.img`
    width: 100%;
    height: auto;
    object-fit: cover;
`;

export const Title = styled.h4`
    color: ${Palette.white.normal};
    position: absolute;
    bottom: 46px;
    left: 12px;
    right: 20px;
    margin: 0;
    ${Text.Mobile.heading4.bold}

    ${Screen.ipad} {
        ${Text.Ipad.heading4}
        bottom: 64px;
        left: 30px;
        right: 30px;
    }
    ${Screen.desktop} {
        ${Text.Desktop.heading4}
    }
`;

export const Experience = styled.span`
    color: ${Palette.white.normal};
    background-color: rgba(25, 33, 39, 0.7);
    border-radius: ${radius.small};
    width: 120px;
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 12px;
    left: 12px;
    ${Text.Mobile.caption.medium}

    ${Screen.ipad} {
        ${Text.Ipad.normal.medium}
        width: 140px;
        bottom: 30px;
        left: 30px;
    }
    ${Screen.desktop} {
        ${Text.Desktop.medium.medium}
    }
`;
